export default "<div *ngIf=\"loading\" class=\"loading\">\n  <div class=\"rotating\">\n  </div>\n  </div>\n  <router-outlet></router-outlet>\n"